var checkIsDefined = function (data) { return typeof data !== "undefined"; };

export { checkIsDefined };
//# sourceMappingURL=nanNullUndef.js.map
